import { render, staticRenderFns } from "./WorkflowModal.vue?vue&type=template&id=4838ddd4"
import script from "./WorkflowModal.vue?vue&type=script&lang=js"
export * from "./WorkflowModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowModal.vue?vue&type=style&index=0&id=4838ddd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports